module.exports = __webpack_public_path__ + "static/img/img_relatedproducts_3.ce6963a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_relatedproducts_3.png
// module id = +Gz+
// module chunks = 0